(() => {
  const trackingPath = window.location.pathname.replace(/\/$/, '').toLowerCase();
  if (trackingPath !== '/apps/17track') return;

  const setText = (selector, value) => {
    document.querySelectorAll(selector).forEach((element) => {
      if (element.textContent.trim() !== value) element.textContent = value;
    });
  };

  const setField = (selector, value) => {
    document.querySelectorAll(selector).forEach((field) => {
      if (field.placeholder !== value) field.placeholder = value;
      if (field.getAttribute('aria-label') !== value) field.setAttribute('aria-label', value);
    });
  };

  const translateTrackingPage = () => {
    setText('.yq-track-page-title', 'Track Your Order');
    setText('.yq-track-tab-order-num', 'Order Number');
    setText('.yq-track-tab-tracking-num', 'Tracking Number');
    setText('[class*="ClassicFormTab"] button[type="submit"] span', 'Track Now');
    setField('#orderForm_order_no', 'Order Number');
    setField('#orderForm_user_email', 'Email');
    setField('#trackingForm_track_no', 'Tracking Number');
  };

  let observer;
  const initialize = () => {
    translateTrackingPage();
    if (observer) return;
    observer = new MutationObserver(translateTrackingPage);
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', translateTrackingPage);
  window.addEventListener(
    'pagehide',
    () => {
      observer?.disconnect();
      observer = undefined;
    },
    { once: true },
  );
})();
